import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DateFormats } from '@uplift/constants';
import { CalendarDateService } from '@uplift/services';
import { TreatPatientMedication, TreatPatientMedicationSelfReported } from '@uplift/types';

export type MedicationItemProps = {
  medication: TreatPatientMedication | TreatPatientMedicationSelfReported;
};

const formatMedicationRefillString = (medication: TreatPatientMedication) => {
  const refills = `${medication.refills} refills`;
  const prescribed = `prescribed ${CalendarDateService.date(medication.prescribed).format(DateFormats['M/D/YY'])}`;
  const filled = medication.filled ? `filled ${CalendarDateService.date(medication.filled).format(DateFormats['M/D/YY'])}` : null;

  return [ refills, prescribed, filled ].filter(x => x).join(', ');
};

const useStyles = makeStyles()((theme) => ({
  drugName: {
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  selfReported: {
    whiteSpace: 'nowrap'
  }
}));

export const MedicationItem: React.VFC<MedicationItemProps> = ({ medication }) => {
  const { classes } = useStyles();

  // not self reported
  if ('dosage' in medication) {
    return (
      <Box mb={2} display="flex" flexDirection="column" gap="2px">
        <Typography variant="body2" className={classes.drugName}>{medication.drugName}</Typography>
        <Typography variant="body2">{medication.dosage}</Typography>
        <Typography variant="body2">{formatMedicationRefillString(medication)}</Typography>
      </Box>
    );
  }

  // self reported
  return (
    <Box mb={1}>
      <Typography variant="body2">
        <span className={classes.drugName}>
          {medication.drugName}
        </span>
        <span className={classes.selfReported}>
            &nbsp;&nbsp;self-reported
        </span>
      </Typography>
    </Box>
  );
};
